export default __webpack_public_path__ + "static/media/Ballroll_00357.ee3edee0.png";